export default "__VITE_ASSET__DE8YVC3N__"